module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-brands-400.ttf?e1fdc9c280d869cf86eb84552127e72a";